import { useEffect, useState } from 'react'
import { cn } from '../utils/cn'
import { fetchLoadingLogoUrl } from '../services/api/clientConfig'
import './RunningLoader.css'

// 吉祥物圖網址由 /api/client-config 提供；取得後記在模組內，之後掛載不必再等
let resolvedLogoUrl: string | null | undefined
// 失敗一次後全站改用替代圖形，避免每次掛載都重發失敗請求
let logoFailed = false

interface RunningLoaderProps {
  /** sm 為橫排小尺寸（對話泡泡、縮圖格），md／lg 為直排 */
  size?: 'sm' | 'md' | 'lg';
  /** 不顯示文字時傳 null；文字結尾的「...」由動畫產生 */
  label?: string | null;
  className?: string;
}

export function RunningLoader({ size = 'md', label = '載入中', className }: RunningLoaderProps) {
  const [logoUrl, setLogoUrl] = useState<string | null>(resolvedLogoUrl ?? null)
  const [failed, setFailed] = useState(logoFailed)
  const [loaded, setLoaded] = useState(false)
  const useImage = logoUrl !== null && !failed

  useEffect(() => {
    if (resolvedLogoUrl !== undefined) return
    let active = true
    fetchLoadingLogoUrl().then((url) => {
      resolvedLogoUrl = url
      if (active) setLogoUrl(url)
    })
    return () => {
      active = false
    }
  }, [])

  return (
    <div role="status" aria-live="polite" className={cn('rl-root', `rl-${size}`, size === 'sm' && 'rl-inline', className)}>
      <div className="rl-stage" aria-hidden="true">
        <span className="rl-shadow" />
        <span className="rl-dust" />
        <span className="rl-dust" />
        <span className="rl-dust" />
        <div className="rl-runner">
          {/* 圖下載完成前先顯示替代圖形，避免只剩影子 */}
          {(!useImage || !loaded) && <div className="rl-fallback" />}
          {useImage && logoUrl !== null && (
            <img
              src={logoUrl}
              alt=""
              draggable={false}
              className={loaded ? undefined : 'rl-pending'}
              onLoad={() => setLoaded(true)}
              onError={() => {
                logoFailed = true
                setFailed(true)
              }}
            />
          )}
        </div>
      </div>
      {label !== null ?
        <span className="rl-label">{label}</span> :
        <span className="sr-only">載入中</span>}
    </div>
  )
}

export default RunningLoader
